import { Box, styled } from '@mui/material';
import React from 'react';

export const Logo = () => (
  <Box>
    <StyledImg src="img/logo_light.webp" alt="コード進行みえるくん" />
  </Box>
);

const StyledImg = styled('img')({
  width: '300px',
  height: '114.5px',
  imageRendering: '-webkit-optimize-contrast',
});
